import { createContext } from 'react';

export const ConfirmModalContext = createContext(null);
